import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetGamerInformation } from '../../store/thunk/setGetGamerInformation';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Dialog from '@material-ui/core/Dialog';
import {useFormik, FormikContext} from "formik";
import { setPostUpdateBalance } from '../../store/thunk/setPostUpdateBalance';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '100%', 
        height: 120, 
        columnGap: 10
    },
    wrapBlock: {
        width: '33%',     
        background: '#1b2039',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 20
    },
    wrapTitle: {
        color: '#fff', 
        fontSize: 20, 
        fontWeight: 700, 
        borderBottom: '2px solid #b0b0b0', 
        width: '100%',
        textAlign: 'center', 
        paddingBottom: 10
    },
    wrapDescription: {
        color: '#fff', 
        fontSize: 30, 
        fontWeight: 700, 
        width: '100%', 
        textAlign: 'center', 
        paddingTop: 10
    },
    gold: {
        color: 'gold'
    }
}));

const Users = ({groups}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [isOpenModal, setIsOpenModal] = React.useState(false);

    const onSubmit = (store) => {
        store.id = view.id;
        dispatch(setPostUpdateBalance(store, setIsOpenModal));
        formik.resetForm();
    }

    const initialValues = {
        amount: 0,
        method: ''
    }

    const formik = useFormik({onSubmit, initialValues});

    React.useEffect(() => {
        dispatch(setGetGamerInformation({
            groups
        }))
    }, [groups, dispatch]);

    const users = useSelector(state => state.groups.gamer_information)
    const view = useSelector(state => state.groups.view);

    return (
        <div className={classes.root}>
            <div className={classes.wrapBlock}>
                <div className={classes.wrapTitle} style={{position: 'relative'}}>
                    <span style={{
                        marginLeft: '12px',
                        padding: '5px',
                        color: 'rgb(47, 47, 47)',
                        background: 'rgb(252, 52, 80)',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        position: 'absolute',
                        top: -5, 
                        left: 0
                    }}
                        onClick={() => {
                            setIsOpenModal(true);
                            formik.setFieldValue('method', 'delete')
                        }}
                    >
                        Убрать
                    </span>
                    <span>
                        Баланс
                    </span>
                    <span style={{
                        marginLeft: '12px',
                        padding: '5px',
                        color: 'rgb(47, 47, 47)',
                        background: 'rgb(252, 52, 80)',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        position: 'absolute',
                        top: -5, 
                        right: 0
                    }}
                        onClick={() => {
                            setIsOpenModal(true);
                            formik.setFieldValue('method', 'add')
                        }}
                    >
                        Добавить
                    </span>
                </div>
                
                <span className={classes.wrapDescription}>
                    {view.balance ? view.balance.toFixed(2) : view.balance} ₽
                </span>
            </div>
            <div className={classes.wrapBlock}>
                <span className={classes.wrapTitle}>
                    Игроков за сегодня
                </span>
                <span className={classes.wrapDescription}>
                    0&nbsp;/&nbsp; 
                    <span className={classes.gold}>
                        {users.count_gamer}
                    </span>
                </span>
            </div>
            <div className={classes.wrapBlock}>
                <span className={classes.wrapTitle}>
                    Количество игроков
                </span>
                <span className={classes.wrapDescription}>
                    <span className={classes.gold}>
                        {users.count_gamer}
                    </span>
                </span>
            </div>
            <Dialog onClose={() => setIsOpenModal(false)} open={isOpenModal}>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit} >
                        <div style={{width: 300, padding: 20, display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                            <h3 style={{color: '#0e0e0e', padding: 0, margin: 0, paddingBottom: 8, marginBottom: 12, borderBottom: '1px solid #eee', width: '100%', textAlign: 'center'}}>
                                {formik.values.method === 'add' ? 'Добавить кредиты' : formik.values.method === 'delete' ? 'Убрать кредиты' : 'Неизвестно'}
                            </h3>
                            <div style={{width: '100%'}}>
                                <label htmlFor="amount">
                                    <span>Количество кредитов</span>
                                    <input 
                                        type="text"
                                        style={{border: '1px solid #eee', outline: 'none', padding: 10, width: 'calc(100% - 20px)', borderRadius: 4}}
                                        value={formik.values.amount}
                                        onChange={(v) => {
                                            if (!isNaN(+v.target.value)) {
                                                formik.setFieldValue('amount', +v.target.value);
                                            }
                                        }}
                                    />
                                </label>
                                <div style={{width: '100%', marginTop: 20}}>
                                    <span style={{
                                        color: '#141b33',
                                        cursor: 'pointer',
                                        padding: '10px',
                                        background: '#ffc324',
                                        borderRadius: '4px',
                                        width: 'calc(100% - 20px)',
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}
                                        onClick={() => {
                                            formik.submitForm()
                                        }}
                                    >
                                         {formik.values.method === 'add' ? 'Пополнить' : formik.values.method === 'delete' ? 'Убрать' : 'Неизвестно'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </FormikContext.Provider>
            </Dialog>
        </div>
    )
}

export default Users;